export enum USER_MESSAGE_TYPES{
    USER ="me",
    ASSISTANT = "other",
    ERROR = "error",
    SYSTEM = "system"
}